<template>
  <div>
    <!-- Statistics Cards: Clients -->
    <section id="statistics-cards">
      <div class="row">
        <!-- Total Clients -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-1" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="UsersIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.total }}</h2>
              <p class="card-text">Total Clients</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- New This Month -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-1" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="UserPlusIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.new_this_month }}</h2>
              <p class="card-text">New This Month</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- Churn Rate -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-1" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="BriefcaseIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.churn_rate }}</h2>
              <p class="card-text">Paid Client</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- Trial Clients -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-1" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="UserCheckIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.trial }}</h2>
              <p class="card-text">Trial Clients</p>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </section>

    <!-- Statistics Cards: Active / Cancelled / Local Totals / Upcoming -->
    <section id="statistics-cards" class="mt-4">
      <div class="row">
        <!-- Active Clients -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-4" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="UserCheckIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.active }}</h2>
              <p class="card-text">Active Clients</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- Cancelled Clients -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-4" v-if="clients">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="UserXIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ clients.cancelled }}</h2>
              <p class="card-text">Cancelled Clients</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- Local Payments MRR / ARR -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-4" v-if="localTotals">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="CreditCardIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">
                {{ localTotals.mrr }} / {{ localTotals.arr }}
              </h2>
              <p class="card-text">Payments (MRR / ARR)</p>
            </b-card-body>
          </b-card>
        </div>

        <!-- Upcoming Renewals / Expected Revenue -->
        <div class="col-xl-3 col-md-4 col-sm-6 mb-4" v-if="localTotals">
          <b-card no-body class="h-100">
            <b-card-body class="text-center d-flex flex-column justify-content-center align-items-center h-100">
              <feather-icon icon="CalendarIcon" class="mb-2" size="40" />
              <h2 class="font-weight-bolder mb-0">{{ localTotals.upcoming_renewals }}</h2>
              <p class="card-text">
                Upcoming Renewals <br />
                Expected Revenue: {{ localTotals.upcoming_revenue }}
              </p>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </section>


    <section class="mt-4">
      <div class="row">
        <!-- MRR Growth -->
        <div class="col-lg-6 mb-3">
          <div class="card shadow-sm">
            <div class="card-header">MRR Growth (Last 6 Months)</div>
            <div class="card-body">
              <canvas id="mrrChart"></canvas>
            </div>
          </div>
        </div>

        <!-- Churn vs New Clients -->
        <div class="col-lg-6 mb-3">
          <div class="card shadow-sm">
            <div class="card-header">Churn vs New Clients</div>
            <div class="card-body">
              <canvas id="churnChart"></canvas>
            </div>
          </div>
        </div>
      </div>

      <!-- Clients by Plan -->
      <div class="row">
        <div class="col-lg-4 mb-10">
          <b-tabs content-class="mt-2">

            <b-tab title="Packages" active>
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Package Wise Client</b-card-title>
                </b-card-header>
                <b-card-body>
                  <canvas id="planChart"></canvas>
                </b-card-body>
              </b-card>
            </b-tab>
          </b-tabs>
          
        </div>
        <div class="col-lg-8 mb-2">
          <b-tabs content-class="mt-2">
            <!-- Payments Tab -->
            <b-tab title="Payments" active>
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Payment Breakdown</b-card-title>
                </b-card-header>
                <b-card-body>
                  <b-table
                    :items="paymentMethods"
                    :fields="paymentFields"
                    striped
                    hover
                  ></b-table>
                </b-card-body>
              </b-card>
            </b-tab>

            <!-- Packages Tab -->
            <!-- <b-tab title="Packages">
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Package Breakdown</b-card-title>
                </b-card-header>
                <b-card-body>
                  <p>Total Packages: {{ packages.total }}</p>
                  <b-table
                    :items="packageMethods"
                    :fields="packageFields"
                    striped
                    hover
                  ></b-table>
                </b-card-body>
              </b-card>
            </b-tab> -->

            <!-- Payment Methods Tab -->
            <!-- <b-tab title="Payment Methods">
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Payment Methods Overview</b-card-title>
                </b-card-header>
                <b-card-body>
                  <p>Total Methods Used: {{ paymentMethodCount.total_methods_used }}</p>
                  <b-table
                    :items="paymentMethodList"
                    :fields="paymentMethodFields"
                    striped
                    hover
                  ></b-table>
                </b-card-body>
              </b-card>
            </b-tab> -->

            <!-- New Tab: Top Companies -->
            <b-tab title="Top Companies">
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Top Paying Companies</b-card-title>
                </b-card-header>
                <b-card-body>
                  <b-table
                    :items="topCompanies"
                    :fields="topCompanyFields"
                    striped
                    hover
                  ></b-table>
                </b-card-body>
              </b-card>
            </b-tab>

            <b-tab title="Package & Payment Wise Clients">
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Package & Payment Method Wise Clients</b-card-title>
                </b-card-header>
                <b-card-body>
                  <b-table
                    :items="paymentPackageWiseClients"
                    :fields="paymentPackageFields"
                    striped
                    hover
                  >
                  </b-table>
                </b-card-body>
              </b-card>
            </b-tab>


            <!-- New Tab: Recent Transactions -->
            <!-- <b-tab title="Recent Transactions">
              <b-card no-body>
                <b-card-header>
                  <b-card-title>Recent Transactions</b-card-title>
                </b-card-header>
                <b-card-body>
                  <b-table
                    :items="recentTransactions.data"
                    :fields="recentTransactionFields"
                    striped
                    hover
                    responsive
                  >
                    <template #cell(amount_paid)="data">
                      ৳{{ parseFloat(data.item.amount_paid).toFixed(2) }}
                    </template>

                    <template #cell(created_at)="data">
                      {{ new Date(data.item.created_at).toLocaleString() }}
                    </template>
                  </b-table>

                  <b-pagination
                    v-model="currentTransactionPage"
                    :total-rows="recentTransactions.total"
                    :per-page="recentTransactions.per_page"
                    @change="fetchTransactionsPage"
                    align="center"
                    class="mt-3"
                  />

                </b-card-body>
              </b-card>
            </b-tab> -->
            
          </b-tabs>
        </div>
      </div>
    </section>


    <!-- Tabs Section -->
    <section class="mt-4">
      
    </section>
    
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BTable,
  BTabs,
  BTab,
  BPagination,
} from "bootstrap-vue";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import { Chart } from "chart.js"; 
import { mapGetters } from "vuex";
import store from "@/store";
import {
  DASHBOARD_ACCESS,
  DASHBOARD_BDT,
  DASHBOARD_USD,
  DASHBOARD_DEMO,
} from '@/helpers/superAdminPermissionConstant'
export default {
  name: "SuperAdminDashboardView",
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BTable,
    BTabs,
    BTab,
    BPagination,
    FeatherIcon,
  },
  data() {
    return {
      DASHBOARD_ACCESS,
      DASHBOARD_BDT,
      DASHBOARD_USD,
      DASHBOARD_DEMO,
      charts: null,
      clients: null,
      payments: null,
      packages: null,
      paymentMethodCount: null,
      localTotals: null,
      loading: true,
      error: null,
      paymentFields: [
        { key: "method", label: "Payment Method" },
        { key: "mrr", label: "Monthly Recurring Revenue (MRR)" },
        { key: "arr", label: "Annual Recurring Revenue (ARR)" },
        { key: "total", label: "Total Revenue" },
        { key: "upcoming_renewals", label: "Upcoming Renewals" },
        { key: "upcoming_revenue", label: "Expected Revenue" },
      ],
      packageFields: [
        { key: "method", label: "Payment Method" },
        { key: "count", label: "Package Count" },
      ],
      paymentPackageWiseClients: [],
      paymentPackageFields: [
        { key: "package_name", label: "Package Name" },
        { key: "total_companies", label: "Total Companies" },
      ],

      paymentMethodFields: [
        { key: "method", label: "Payment Method" },
        { key: "count", label: "Number of Clients" },
      ],
      topCompanies: [],
      topCompanyFields: [
        { key: "name", label: "Company Name" },
        { key: "email", label: "Email" },
        { key: "package_name", label: "Package Name" },
      ],
      recentTransactions: {
        data: [],
        total: 0,
        per_page: 5,
        current_page: 1
      },
      recentTransactionFields: [
        { key: "company_name", label: "Company Name" },
        { key: "company_email", label: "Email" },
        { key: "gateway", label: "Payment Gateway" },
        { key: "amount_paid", label: "Amount Paid" },
        { key: "created_at", label: "Date" },
      ],
      currentTransactionPage: 1
    };
  },
  created() {
    this.fetchDashboard();
  },
  computed: {
    ...mapGetters({
      permissions: 'superAdminAuthModule/getPermissions',
    }),
  },
  methods: {
    async fetchDashboard() {
      try {
        let url = '';
        if (this.$permissionAbility(this.DASHBOARD_BDT, store.getters["superAdminAuthModule/getPermissions"])) {
          url = "/api/super-admin/dashboard/bd";
        } else if (this.$permissionAbility(this.DASHBOARD_USD, store.getters["superAdminAuthModule/getPermissions"])) {
          url = "/api/super-admin/dashboard/usd?demo=0";
        } else if (this.$permissionAbility(this.DASHBOARD_DEMO, store.getters["superAdminAuthModule/getPermissions"])) {
          url = "/api/super-admin/dashboard/usd?demo=1";
        }
        this.loading = true;
        const response = await this.$api.get(url);
        const data = response.data;

        this.clients = data.clients;
        this.payments = data.payments;
        this.packages = data.packages;
        this.paymentMethodCount = data.payment_methods;
        this.localTotals = data.local_totals;
        this.charts = data.charts; 
        this.topCompanies = data.top_companies;
        this.paymentPackageWiseClients = data.payment_method_and_package_wise_client;

        await this.fetchTransactionsPage(1);

        this.$nextTick(() => {
          this.renderCharts();
        });
        
        this.loading = false;
      } catch (err) {
        this.error = "Failed to load dashboard data";
        console.error(err);
        this.loading = false;
      }
    },
    async fetchTransactionsPage(page = 1) {
      try {
        let url = '';
        if (this.$permissionAbility(this.DASHBOARD_BDT, this.permissions)) {
          url = "/api/super-admin/transactions/bd";
        } else if (this.$permissionAbility(this.DASHBOARD_USD, store.getters["superAdminAuthModule/getPermissions"])) {
          url = "/api/super-admin/transactions/usd";
        } else if (this.$permissionAbility(this.DASHBOARD_DEMO, store.getters["superAdminAuthModule/getPermissions"])) {
          url = "/api/super-admin/transactions/demo";
        }
        const response = await this.$api.get(url, {
          params: { page, per_page: this.recentTransactions.per_page }
        });

        // API returns Laravel pagination object
        this.recentTransactions = {
          data: response.data.data,
          total: response.data.total,
          per_page: response.data.per_page,
          current_page: response.data.current_page,
          last_page: response.data.last_page
        };

        this.currentTransactionPage = this.recentTransactions.current_page;
      } catch (err) {
        console.error("Failed to fetch transactions page", err);
      }
    },
    renderCharts() {
      // MRR Growth Line Chart
      if (this.charts?.mrr_growth) {
        const ctx = document.getElementById("mrrChart");
        new Chart(ctx, {
          type: "line",
          data: {
            labels: this.charts.mrr_growth.map((d) => d.month),
            datasets: [
              {
                label: "MRR",
                data: this.charts.mrr_growth.map((d) => d.mrr),
                borderColor: "#007bff",
                backgroundColor: "rgba(0, 123, 255, 0.2)",
                fill: true,
                tension: 0.3,
              },
            ],
          },
          options: { responsive: true, maintainAspectRatio: false },
        });
      }

      // Churn vs New Clients Bar Chart
      if (this.charts?.churn_vs_new_clients) {
        const ctx = document.getElementById("churnChart");
        new Chart(ctx, {
          type: "bar",
          data: {
            labels: this.charts.churn_vs_new_clients.map((d) => d.month),
            datasets: [
              {
                label: "New Clients",
                data: this.charts.churn_vs_new_clients.map((d) => d.new_clients),
                backgroundColor: "rgba(40, 167, 69, 0.7)",
              },
              {
                label: "Churn",
                data: this.charts.churn_vs_new_clients.map((d) => d.churn),
                backgroundColor: "rgba(220, 53, 69, 0.7)",
              },
            ],
          },
          options: { responsive: true, maintainAspectRatio: false },
        });
      }

      // Clients by Plan Donut Chart
      if (this.charts?.clients_by_plan) {
        const ctx = document.getElementById("planChart");
        new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: Object.keys(this.charts.clients_by_plan),
            datasets: [
              {
                data: Object.values(this.charts.clients_by_plan),
                backgroundColor: [
                  "#007bff",
                  "#28a745",
                  "#ffc107",
                  "#dc3545",
                  "#6610f2",
                  "#17a2b8",
                ],
              },
            ],
          },
          options: { responsive: true, maintainAspectRatio: false },
        });
      }
    },
  },
  computed: {
    paymentMethods() {
      if (!this.payments) return [];
      return Object.keys(this.payments).map((method) => {
        const p = this.payments[method];
        return {
          method: method.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase()),
          total: p.total,
          upcoming_renewals: p.upcoming_renewals,
          upcoming_revenue: p.upcoming_revenue,
          mrr: p.mrr,
          arr: p.arr,
        };
      });
    },
    packageMethods() {
      if (!this.packages?.method_counts) return [];
      return Object.keys(this.packages.method_counts).map((method) => ({
        method: method.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        count: this.packages.method_counts[method],
      }));
    },
    paymentMethodList() {
      if (!this.paymentMethodCount?.method_counts) return [];
      return Object.keys(this.paymentMethodCount.method_counts).map((method) => ({
        method: method.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase()),
        count: this.paymentMethodCount.method_counts[method],
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.custom-card-statistics .statistics-body {
  padding: 0rem 2.4rem 1rem !important;
}
.lead-table {
  padding: 0px !important;
}
</style>
